module.exports = __webpack_public_path__ + "img/cloud-logo.8e1bcfc6.png";